import { openResourcesPopup } from "@/common/helpers/popupHelper";
import { MessagingOfferNotification } from "@/common/models/messagingNotification";
import { WrapUp } from "@/common/models/wrapUp";
import { ServerEvent } from "@/common/notification";
import {
	QueuesWithResourcesActions,
	QueuesWithResourcesState,
	useQueuesWithResourcesStore,
} from "@/common/stores/nonpersistingStores/queues";
import { notificationListener } from "@/hooks/notification";
import {
	AutoOpenTrigger,
	InteractionDto,
	InteractionOperations,
} from "@/repository/models";

export const useResourcesOpener = () => {
	const queueWithResourcesStore = useQueuesWithResourcesStore(
		(store: QueuesWithResourcesState & QueuesWithResourcesActions) => store
	);

	notificationListener(ServerEvent.WrapUpStarted, (wrapUp: WrapUp) => {
		if (wrapUp.isFromCall) {
			return;
		}

		openResourcesPopup(
			queueWithResourcesStore.getQueueById(wrapUp.queueRef),
			AutoOpenTrigger.WhenClosed
		);
	});

	notificationListener(
		ServerEvent.MessagingOffered,
		(messagingInvite: MessagingOfferNotification) => {
			openResourcesPopup(
				queueWithResourcesStore.getQueueById(messagingInvite.queueId),
				AutoOpenTrigger.WhenOffering
			);
		}
	);

	notificationListener(
		ServerEvent.ActiveMessagingChanged,
		(interaction: InteractionDto) => {
			const queue = queueWithResourcesStore.getQueueById(interaction.queueId);

			if (interaction.changeType === InteractionOperations.Removed) {
				openResourcesPopup(queue, AutoOpenTrigger.WhenClosed);
			}
		}
	);

	notificationListener(
		ServerEvent.MessagingAccepted,
		(interaction: InteractionDto) => {
			openResourcesPopup(
				queueWithResourcesStore.getQueueById(interaction.queueId),
				AutoOpenTrigger.WhenHandlingAccepted
			);
		}
	);
};
